import type { GradeStructureApiResponse } from "@ts/interfaces/structure/api/gradeStructureApiInterface";
import { get } from "./httpClient";

export const getGradeStructure = async (
  gradeCode: number
): Promise<GradeStructureApiResponse> => {
  return await get<GradeStructureApiResponse>(
    `/course/grade/${gradeCode}/structure`
  );
};

export const structureApi = {
  getGradeStructure
};
